<template>
  <div id="app" class="container" v-bind:class="[showSubMenu ? 'ausstellung' : 'others']">
    <header>
    <div class="buttons">
      <a class="left mobile" href="#" v-on:click="openLeft"><img class="burger" src="/img/svg/menu.svg"></a>
    </div>
    </header>
    <nav v-bind:class="['bgcolor',{ 'nav-hidden' : Left }]">
      <a class="left mobile" href="#" v-on:click="openLeft"><img class="closebutton" src="/img/svg/x.svg"></a>
      <side></side>
    </nav>
    <main v-bind:class="[{ 'hideOverflow' : showSubMenu }]">
      <div v-if="this.$store.state.mute == true">
        <audio id="player" preload="metadata" autoplay>
          <source src="/mp3/A-Inka.mp3" type="audio/mpeg">
          Your browser does not support the audio element.
        </audio>
        <div class="audiobuttons">
           <button onclick = "document.getElementById('player').play()">Start</button>
           <button onclick = "document.getElementById('player').pause()">Pause</button>
           <button onclick = "document.getElementById('player').volume += 0.2">Lauter</button>
           <button onclick = "document.getElementById('player').volume -= 0.2">Leiser</button>
        </div>
      </div>
      <videoplayer v-bind:postsrc="'/videos/Ausstellung/A-Inka.mp4'" v-if="this.$store.state.deaf == true" v-bind:autoplay="true"  class=""></videoplayer>
      <router-view name="main" />
    </main>
    <aside name="side">
      <router-view name="nav"/>
    </aside>
    <footer name="footer">
    </footer>
  </div>
</template>

<script>
import side from '@/components/Includes/side.vue'
import videoplayer from '@/components/Includes/videoplayerSmall.vue'
export default {
  name: 'App',
  data: function () {
    return {
      navOpen: true
    }
  },
  methods: {
    openLeft: function () {
      if (this.$store.state.openLeft) {
        this.$store.commit('toggleLeft', false)
      } else {
        this.$store.commit('toggleLeft', true)
      }
    }
  },
  computed: {
    showSubMenu () {
      return this.$store.state.showSubMenu
    },
    Left () {
      return this.$store.state.openLeft
    }
  },
  components: {
    side,
    videoplayer
  }
}
</script>

<style>

body{
  transition: 0.8s;
}

@media screen and (max-width:414px){
.ausstellung {
  display:grid;
}
.ausstellung header{
  display:none;
}
}

@media (orientation:portrait) and (max-width:768px){
.ausstellung {
  display:grid;
}
.ausstellung header{
  display:none;
}
}
.audiobuttons button{
  font-family: 'Lato', sans-serif;
}

.hideOverflow{
  overflow:hidden;
}

header {
  grid-area: header;
  height:90px;
}

.buttons img, .closebutton{
  width:30px;
  padding:20px;
  z-index: 10;
}

.buttons{
  width:100%;
}

nav{
    grid-area: nav;
    overflow:hidden;
    top: 0;
    bottom: 0;
    position: fixed;
    width: auto;
    left: 0px;
    z-index: 10;
}

.nav-hidden{
  left: -200px;
}

main {
  grid-area: content;
}

aside {
  grid-area: side;
  grid-column: 1;
  overflow:hidden;
}

footer {
  grid-area: footer;
  display:none;
}

@media (min-width: 890px) {
  body{
    overflow:hidden;
  }
  .others {
    display: grid;
    grid-template-areas:
      "header header header"
      "nav content  side"
      "footer footer footer";

    grid-template-columns: 200px 1fr 120px;
    grid-template-rows: auto 1fr auto;
    width:100vw;
    height: 100vh;
  }
  .ausstellung {
    display: grid;
    grid-template-areas:"nav content side";
    grid-template-columns: 100px 1fr 120px;
    width:100vw;
    height: 100vh;
  }

  header {
    height:0px;
    z-index: 11;
  }

  nav{
    position: relative;
    grid-column:3;
  }

  .mobile{
    display:none;
  }
  .nav-hidden{
    left: 0px;
    display:block;
  }
  nav{
    width:125px;
  }
}

@media (orientation: landscape) and (max-width:981px){

body{
  overflow:hidden;
}
aside{
  grid-column:3;
}
header{
  display: none;
}
footer{
  display:none;
}

.nav-hidden{
  left: -200px;
  display:block;
}
nav{
  grid-column:1;
}

.others {
  display:grid;
grid-template-areas:
  "nav content side";

  grid-template-columns: 100px 1fr 137px;
  grid-template-rows: auto 1fr auto;
  grid-gap: 10px;
  width:100vw;
  height: 100vh;
}

.ausstellung {
  grid-template-areas:
    "nav content side";

    grid-template-columns: 200px 1fr 120px;
    grid-template-rows: auto 1fr auto;
    grid-gap: 10px;
    width:100vw;
    height: 100vh;
  }

  .ausstellung aside{
    position:absolute;
    transform: translateY(-100%);
    margin-top:-5px;

  }
  .others .closebutton{
    display:none;
  }

  .others .nav-hidden{
    left:0 !important;
  }
  .others nav{
    margin-top:70px;
    display: flex;
    margin-left:0;
    flex-direction: column;
    justify-content: center;
  }
  .ausstellung nav{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
}

@media (orientation: landscape) and (max-height: 414px) {
  .ausstellung, .others {
    grid-template-columns: 137px 1fr 125px;
  }
}

@media (orientation: landscape) and (max-height: 411px) {
  .ausstellung, .others {
    grid-template-columns: 137px 1fr 125px;
  }
}

@media (orientation: landscape) and (max-height: 375px) {
  .ausstellung, .others {
    grid-template-columns: 125px 1fr 125px;
  }
}

@media (orientation: landscape) and (max-height: 360px) {
  .ausstellung, .others {
    grid-template-columns: 120px 1fr 125px;
  }
}

@media (orientation: landscape) and (max-height: 320px) {
  .ausstellung, .others {
    grid-template-columns: 106px 1fr 125px;
  }
}
</style>
